import { scarpaGray200, scarpaGray25, scarpaGray900, spanishViridian25, spanishViridian500 } from '@habitech/shared';
import styled from 'styled-components';

export const Wrapper = styled.div`
    padding: 20px;
    margin-top: 20px;
    background: ${scarpaGray25};
    border-radius: 10px;
    border: 1px solid ${scarpaGray200};
    &.table {
        overflow: scroll hidden;
        &::-webkit-scrollbar {
            width: 0px;
            height: 0px;
        }
    }
    label {
        margin-top: 10px;
    }
    input[data-id='testing_discount'] {
        text-align: right;
        &::placeholder {
            text-align: left;
        }
    }
    button[data-id='button-send-suggestions'] {
        margin: auto;
        margin-bottom: 20px;
    }
    button[data-id="test_user_type"] {
        width: 100%;
        margin-bottom: 20px;
    }
    .loading {
        height: 200px;
    }
    .button {
        align-content: end;
    }
    @media ${({ theme }) => theme.screenSizes.laptop} {
        overflow: unset;
        &.table {
            overflow: hidden;
        }
    }
`;

export const IconPercentage = styled.div`
    margin: 0 12px 0 0;
`;

export const WrapperIcon = styled.div`
    margin: 0px 0 10px;
    display: flex;
    align-items: center;
    gap: 10px;
    color: ${scarpaGray900};
    font-weight: 500;
`;

export const InfoUser = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    gap: 10px;
    color: ${scarpaGray900};
    font-weight: 500;
    font-size: 14px;
    > .item-user-info {
        border: 1px solid ${scarpaGray200};
        border-radius: 10px;
        padding: 8px 12px;
        background: ${scarpaGray25};
        display: flex;
        align-items: center;
        gap: 6px;
        &[data-poc="true"] {
            background: ${spanishViridian25};
            border-color: ${spanishViridian500};
            color: ${spanishViridian500};
        }
    }
`;